module.exports = __webpack_public_path__ + "img/top1.f0013873.svg";